import { leaveTable } from "../actions/leaveTable";
import { replace } from "connected-react-router";
import { orderApi } from "src/features/order/orderApi";
import { getAuthHeaders } from "src/common/auth/auth";

const KEY = "MEANDU_DA";

const getConfirmationKey = (locationId: string) => `${KEY}-${locationId}`;

export const getJsonAuthHeaders = async (): Promise<Headers> => {
    const headers = await getAuthHeaders();
    headers.append("Content-Type", "application/json");

    return headers;
};

export const confirmNoAllergies = async (locationId: string, partyId: string) => {
    saveDietaryAllergiesConfirmation(locationId);

    const headers = await getJsonAuthHeaders();

    await orderApi.send(`/${locationId}/${partyId}/dietary-allergy-confirmation/no-allergies`, {
        method: "POST",
        headers,
    });
};

export const confirmAllergies = async (dispatch: any, locationId: string, partyId: string) => {
    dispatch(leaveTable());
    dispatch(replace("/join-table"));

    const headers = await getJsonAuthHeaders();

    await orderApi.send(`/${locationId}/${partyId}/dietary-allergy-confirmation/has-allergies`, {
        method: "POST",
        headers,
    });
};

export const showConfirmDietaryAllergiesModal = async (locationId: string, partyId: string) => {
    const headers = await getJsonAuthHeaders();

    await orderApi.send(`/${locationId}/${partyId}/dietary-allergy-confirmation-shown`, {
        method: "POST",
        headers,
    });
};

const makeClearStorageHandler = (locationId: string) => () => {
    window.localStorage.removeItem(getConfirmationKey(locationId));
};

export const saveDietaryAllergiesConfirmation = (locationId: string) => {
    window.localStorage.setItem(getConfirmationKey(locationId), new Date().getTime().toString());
    const handler = makeClearStorageHandler(locationId);

    document.removeEventListener("logout", handler);
    document.addEventListener("logout", handler);
};

const hasConfirmedToday = (date: string | null) => {
    if (!date) return false;
    const d1 = new Date();
    const d2 = new Date(+date);
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
};

export const getDietaryAllergiesConfirmation = (locationId: string) => {
    try {
        return hasConfirmedToday(window.localStorage.getItem(getConfirmationKey(locationId)));
    } catch (err) {
        return false;
    }
};
